import { Routes, Route } from "react-router-dom";
import Login from "./Pages/Authentication/Login";
import AppLayout from "./layout/Layout";
import PrintForm from "./Pages/Booking/Survey/print/PrintForm";

const App = () => {

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path=":surveyId/print-survey" element={<PrintForm displayLinks={true} />} />
      <Route path=":visitId/print-visit" element={<PrintForm displayLinks={true} />} />
      <Route path=":surveyId/share-survey" element={<PrintForm displayLinks={false} />} />
      <Route path=":visitId/share-visit" element={<PrintForm displayLinks={false} />} />
      <Route path=":surveyId/customer-report-survey" element={<PrintForm displayLinks={false} customerReport /> } />
      <Route path=":visitId/customer-report-visit" element={<PrintForm displayLinks={false} customerReport /> } />
      <Route
        path=":installationId/print-installation"
        element={<PrintForm displayLinks={true} />}
      />
      <Route
        path=":installationId/share-installation"
        element={<PrintForm displayLinks={false} />}
      />
      <Route
        path=":installationId/customer-report-installation"
        element={<PrintForm displayLinks={false} customerReport />}
      />
      <Route path="/*" element={<AppLayout />} />
    </Routes>
  );
};

export default App;
